import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { BoxRes } from '../../types/Box';
import { ApiError } from '../../types/Error';
import { getBox } from '../Scans';

export const getBoxQueryKey = (boxId: string | number | undefined) => ['box', boxId ? String(boxId) : null];

interface UseGetBoxProps {
    boxId: string | undefined;
    onError?: (err: ApiError) => void;
}

export const useGetBox = ({ boxId, onError }: UseGetBoxProps): UseQueryResult<BoxRes | undefined, ApiError> => {
    const boxQueryResults = useQuery<BoxRes | undefined, ApiError>({
        queryKey: getBoxQueryKey(boxId),
        queryFn: () => {
            if (!boxId) return Promise.resolve(undefined);
            return getBox(boxId);
        },
        retry: false,
        enabled: Boolean(boxId)
    });

    if (boxQueryResults.error && onError) {
        onError(boxQueryResults.error);
    }

    return boxQueryResults;
};
